module.exports = __webpack_public_path__ + "96a1ab1fd6e0e8f252eef63b727e5403.png";